var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-row",class:[
    `lines-${_vm.lineHeightsType.id}`,
    {
      'is-child': _vm.purchase.parentId,
      'is-first-child': _vm.purchase.isFirstChild,
      'is-updated': _vm.purchase.isUpdated,
      'is-duplicated': _vm.purchase.isDuplicated,
      'is-new': _vm.purchase.isNew && _vm.highlightNew,
      'is-last-row': _vm.purchase.isLastRow,
      'is-collapsed': _vm.purchase.isCollapsed,
      'table-row-enter': _vm.animation === 'enter',
      'table-row-leave': _vm.animation === 'leave',
    },
  ],style:({ '--row-height': _vm.lineHeightsType.height + 'px' }),attrs:{"data-id":_vm.purchase.id}},_vm._l((_vm.columns),function(column){return _c('div',{key:column.field,staticClass:"cell",class:{ 'tree-cell': column.field === 'hidden' },style:(column.style),attrs:{"data-field":column.field}},[_c('div',{staticClass:"cell-content"},[(column.cell?.component)?_c(column.cell.component,{tag:"component",attrs:{"value":_vm.purchase.values[column.field],"row":_vm.purchase,"column":column,"field":column.field}}):(column.field === 'organization')?_c('span',[_vm._v(" "+_vm._s(_vm.purchase.values[column.field].split(";").join(";\u00A0"))+" ")]):_vm._o(_c('span',[_vm._v(" "+_vm._s(_vm.purchase.values[column.field])+" ")]),0,column.field)],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }